import { ReactElement } from 'react'
import { RedirectToClassic } from '../../Common/RedirectToClassic'

export const AgentDynamicScheduling = (): ReactElement => <RedirectToClassic />
